import { Context } from 'portal/Context';
import { IRON, SKY } from 'styles/Colors';
import {
  PAYMENT_ROUTES,
  PAYMENTS_NEW,
  PORTAL,
  UPDATE_PROFILE
} from 'portal/constants/Routes';
import { useLocation } from 'react-router-dom';
import FullHouse from 'images/portal/FullHouse.svg';
import FullProfile from 'images/portal/FullProfile.svg';
import Home from 'images/portal/Home.svg';
import Link from 'portal/Link';
import Profile from 'images/portal/Profile.svg';
import React, { useContext } from 'react';
import SlimDollar from 'images/portal/SlimDollar.svg';

const linkStyle = {
  color: IRON,
  textDecoration: 'none',

  svg: {
    fill: IRON
  }
};

const activeLinkStyle = {
  color: SKY,
  textDecoration: 'none',

  svg: {
    fill: SKY
  }
};

function BaseNavigation({ navigate, containerId, style, mobile }) {
  const { pathname } = useLocation();
  const { loan, permissions } = useContext(Context);

  const handleClick = (id) => {
    window.postHeapAnalytic('track', `[navigation][${id}]`);
  };

  const showPayments = () => {
    if (!permissions.hasFundedLoan) return false;
    return !permissions.reapplyEligible && loan.payoffAmount > 0;
  };

  return (
    <div id={containerId} css={style}>
      <Link
        id='home'
        to={PORTAL}
        navigate={navigate}
        style={pathname === PORTAL ? activeLinkStyle : linkStyle}
        heapCallback={handleClick}
      >
        {pathname === PORTAL ? (
          <FullHouse title='Home' />
        ) : (
          <Home title='Home' />
        )}
        {!mobile && <p>Home</p>}
      </Link>
      {mobile && <hr />}
      {showPayments() && (
        <Link
          id='payments'
          to={PAYMENTS_NEW}
          navigate={navigate}
          disabled={
            loan.oneTimePayments.length > 1 || permissions.underCollections
          }
          style={
            PAYMENT_ROUTES.includes(pathname) ? activeLinkStyle : linkStyle
          }
          heapCallback={handleClick}
        >
          <SlimDollar title='Payments' />
          {!mobile && <p>Make a Payment</p>}
        </Link>
      )}
      {showPayments() && mobile && <hr />}
      <Link
        id='profile'
        to={UPDATE_PROFILE}
        navigate={navigate}
        style={pathname === UPDATE_PROFILE ? activeLinkStyle : linkStyle}
        heapCallback={handleClick}
      >
        {pathname === UPDATE_PROFILE ? (
          <FullProfile title='Profile' />
        ) : (
          <Profile title='Profile' />
        )}
        {!mobile && <p>Profile</p>}
      </Link>
    </div>
  );
}

export default BaseNavigation;
